<template>
  <div class="upload-img">
    <ul class="upload-pic-warp">
      <li v-for="(avatar,index) in avatars" class="avatar-warp">
        <img :src="avatar" alt="">
        <div class="mask" @click="deleteAvatar(index)">
          <img :src="deletePic">
        </div>
      </li>
      <li class="upload-pic" v-show="avatars.length<maxLength">
        <input type="file" name="file" id="input_file" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
               @change="getImgUrl">
        <span class="add-icon">+</span>
        <span>上传照片</span>

      </li>
    </ul>
  </div>
</template>

<script>
  import axios from "axios";
  import deletePic from '../assets/delete.png'

  import {getUploadToken} from '../services/http'

  export default {
    name: "UploadImg",
    props: {
      maxLength: {
        default: 9,
        type: Number,
      }
    },
    data() {
      return {
        deletePic,
        avatars: [],
        token: '',
        uploader: null,
        keys: [],
      }
    },
    mounted() {
      this.getUploadToken();
    },
    methods: {
      deleteAvatar(index) {
        this.avatars = this.avatars.filter((item, i) => i !== index);
        this.keys = this.keys.filter((item, i) => i !== index);
        let keys = this.keys.join(',');
        this.$emit('uploadImg', keys);
      },

      getImgUrl(e) {
        if (!window.FileReader) {
          alert("您的设备不支持图片预览功能，如需该功能请升级您的设备！");
          return;
        }
        let file = e.target.files[0];

        let imageType = /^image\//;
        //是否是图片
        if (!imageType.test(file.type)) {
          alert("请选择图片！");
          return;
        }


        let formData = new FormData();
        formData.append(
          "key", file.lastModified + Math.random().toString().slice(-10) + "",
        );
        formData.append("token", this.token);
        formData.append("file", file);
        let url = 'https://upload.qiniup.com';
        axios.post(url, formData).then(res => {
          this.keys.push(res.data.key);
          let keys = this.keys.join(',');
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (e) => {
            this.avatars.push(reader.result);
            this.$emit('uploadImg', keys);
          };
        }).catch(err => {
          alert('上传失败');
        });


      },

      getUploadToken() {
        getUploadToken().then(res => {
          this.token = res.data.data;
        })
      },

    }
  }
</script>

<style scoped lang="less">
  .upload-img {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .avatar-warp {
      width: 60px;
      height: 60px;
      border: 1px solid rgba(0, 0, 0, .15);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 16px;
      position: relative;
      cursor: pointer;
      margin-bottom: 4px;
      .mask {
        position: absolute;
        width: 52px;
        height: 52px;
        top: 4px;
        left: 4px;
        background: rgba(0, 0, 0, .35);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 16px;
          height: 16px;
        }
      }
      img {
        width: 52px;
        height: 52px;
      }
    }
    .upload-pic-warp {
      display: flex;
      flex-wrap: wrap;
      .upload-pic {
        width: 60px;
        height: 60px;
        border: 1px dotted rgba(0, 0, 0, 0.15);
        font-size: 12px;
        color: rgba(0, 0, 0, 0.35);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        .add-icon{
            font-size: 16px;
        }
        input {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border: none;
          outline: none;
          opacity: 0;
          &:hover {
            cursor: pointer;
          }
        }

      }
    }
  }
</style>